import { createAction, handleActions } from 'redux-actions'

const setSubOrders = createAction('SCREENS/SUBCONTRACTOR_VIEW/SUB_ORDERS/SET_SUB_ORDERS')
const resetSubOrders = createAction('SCREENS/SUBCONTRACTOR_VIEW/SUB_ORDERS/RESET_SUB_ORDERS')

const defaultState = []

const reducer = handleActions(
  {
    [setSubOrders]: (state, { payload }) => payload,
    [resetSubOrders]: () => defaultState,
  },
  defaultState,
)

export { setSubOrders, resetSubOrders, reducer }
